module.exports = __webpack_public_path__ + "static/media/lexus.0c85ddef.png";